import { Component, OnInit, OnDestroy, Input, EventEmitter, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { StepComponent } from './step.component';

export enum Steps {
    ZERO = 0,
    ONE = 1,
    TWO = 2,
    THREE = 3,
    FOUR = 4,
    FIVE = 5,
    SIX = 6,
    SEVEN = 7,
    EIGHT = 8
}

@Component({
    selector: 'ui-steps',
    template:
        `	<div class="steps-viewport">
                <ng-content select="step, [step]"></ng-content>
            </div>
        `,
    host: {
        '[class.steps]':'true'
    }
})

// There are 2 ways of accessing the Stepper's inner data and functions
// 1. by elementRef, by setting an elementRef on stepper tag in html file
//    <stepper #stepperUniqueName></stepper> and then calling stepperUniqueName.activeStepIndex, or stepperUniqueName.next() in the html
// 2. by injecting a reference to the component in the parent component ts file
//    @ViewChild(Stepper) myStepper: Stepper;
//    in this case in the html or ts logic we will be using something like myStepper.activeStepIndex and myStepper.next()
//
// When to use witch?
// Use first version when you want fast, basic almost static stepper functionality with no completx logic that influences the html
// Use second when you need to call stepper functions (next, prev) from functions that do more than just trigger a stepper chanage

// I prefer second :D

export class UiStepsComponent implements OnInit, OnDestroy {

    // flow (optional) - the array of step indexes.
    // if no flow is provided one containing all the steps will be generated.
    @Input() flow: any = [];

    // You should provide a flow only if you need just part of the stepper and not all of it, or if the flow depends on external factors.
    // Provided flows depends on the correct indexing of the steps
    // !the index of the step is not it's name it is it's actual index in the array, so <step [index] will always start from 0 if provided

    // ngmodel like - activeStepIndex (optional)
    // use it when you need to start the flow from any other step than first in flow, or when you need to trigger some event on step change
    // of course you could trigger events on step change, when you call stepper.next() or stepper.prev(), but who knows maybe someone will need this
    // use it like: [activeStepIndex]="nrVar", (activeStepIndexChange)="doSomethingFunc($event)" or [(activeStepIndex)]="nrVar"
    @Input() activeStepIndex: number; // the index of the active step
    @Output() activeStepIndexChange = new EventEmitter<number>();

    private steps: any = [];
    private onDestroy$: Subject<void> = new Subject<void>();

    ngOnInit(){
        this.activeStepIndex = this.activeStepIndex || 0;
        this.activeStepIndexChange.emit(this.activeStepIndex);

        // if no flow is set, one will be genrated based on the number of exiting steps
        if (this.flow.length === 0) {
            this.flow = this.buildFlow(this.steps);
        }
    }

	ngOnDestroy() {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }

    // addStep() and buildFlow() are internal functions, they're only purpose is to generate a default flow
    // this is called in constructor of step, this will generate the stepper witch will then be used to generate a flow
    addStep(step: StepComponent) {
        this.steps.push(step);
    }
    // this will generate the flow if none is given based on the steps added with addStep
    buildFlow(steps){
        const flow = [];
        steps.forEach((el,index) => {
            el.index = el.index || index;
            flow.push(el.index);
        });
        return flow;
    }


    // stepper navigation functions
    // stepper.next() goes to next step, stepper.next(3) skips 3 steps
    next(stepsToSkip = 1, callback?) {
        this.activeStepIndex = this.activeStepIndex + stepsToSkip;
        this.activeStepIndexChange.emit(this.activeStepIndex);
        if(callback) {
            callback();
        }
    }
    // same as next() but in reverse :D
    prev(stepsToSkip = 1, callback?) {
        this.activeStepIndex = this.activeStepIndex - stepsToSkip;
        this.activeStepIndexChange.emit(this.activeStepIndex);
        if(callback) {
            callback();
        }
    }

    resetStepper() {
        this.activeStepIndex = 0;
    }

    getCurrentStep() {
        if ((!this.activeStepIndex && this.activeStepIndex !== 0) || this.flow.length <= this.activeStepIndex) {
            return 0;
        }
        return this.flow[this.activeStepIndex];
    }

    getCurrentStepIndex() {
        return this.activeStepIndex ? this.activeStepIndex : 0;
    }

    getNextStep() {
        const currentIndex = this.activeStepIndex ? this.activeStepIndex : 0;
        if (this.flow.length <= currentIndex) {
            return this.flow.length - 1;
        } else {
            return this.flow[currentIndex + 1];
        }
    }
    //! No last in flow, or first in flow restrictions or functionality were implementet
    //! It's up to you to decide what hapennes in this cases, in the parent's ts file

}


